import { render, staticRenderFns } from "./AddEvalutionModal.vue?vue&type=template&id=b613f36a&"
import script from "./AddEvalutionModal.vue?vue&type=script&lang=js&"
export * from "./AddEvalutionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports